<template>
  <router-view />
</template>
<script>
import { get } from "@/mixins/api";
//import login from './views/Login'
export default {
  data() {
    return {
      user: "",
      permissions: [],
      userpermissions: [],
      ready: 0,
      form: [],
    };
  },
  watch: {
    ready: {
      handler: function (newVal) {
        if (newVal == 2) {
          this.form = [];
          this.permissions.forEach((element) => {
            this.form.push({
              permission: element.name,
              permissionid: element.id,
              active: this.userpermissions.some(
                (x) => x.permissionid == element.id && x.userid == this.user
              ),
            });
            this.loading = false;
            localStorage.setItem(
              "permissions",
              this.form
                .filter((x) => x.active)
                .map((x) => x.permission)
                .join(";")
            );
          });
        }
      },
      immediate: true,
    },
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem("user"));
    if(!user) return ;
    get(`userbyemail/${user.email}`).then((res) => {
      this.user = res.data.data.id;
      get("permissions").then((res) => {
        this.permissions = res.data.data;
        this.ready++;
      });
      get("userpermissions").then((res) => {
        this.userpermissions = res.data.data;
        this.ready++;
      });
    });
    /*  this.$router.push('login') */
    localStorage.getItem("accessToken");
  },
};
</script>
<style lang="scss">
// td:not(.text-actions):not(.text-right),
// th {
//   text-overflow: ellipsis;
//   overflow: hidden;
//   white-space: nowrap;
// }
// table {
//   table-layout: fixed;
//   border-collapse: collapse;
// }
</style>
